import LoadingEllipsis from '@/LoadingEllipsis';
import useCheckExperimentBucket from '~/hooks/useCheckExperimentBucket';

type OwnProps = {
  count: number;
  displayName?: string;
  isLoading?: boolean;
  showCount?: boolean;
};

export default function LabelWithCount({
  count = -1,
  displayName = '',
  isLoading = false,
  showCount = true
}: OwnProps) {
  const showLoading =
    useCheckExperimentBucket('srch-impossible-facets', 'experiment') &&
    isLoading;
  const showWithCount =
    useCheckExperimentBucket('srch-impossible-facets', 'experiment') &&
    showCount &&
    count >= 0 &&
    !showLoading;

  return (
    <div className="flex gap-8 items-baseline">
      <span>{displayName}</span>
      {showLoading && (
        <span>
          <LoadingEllipsis />
        </span>
      )}
      {showWithCount && (
        <span className="!font-bold t-body-xs text-grey-3">
          ({count.toLocaleString()})
        </span>
      )}
    </div>
  );
}
